import { IPosts, IPostsAction } from '../../../types/posts';
import { IGetRequest } from '../../../types/get_request';
import { options } from '../seo/seo';
import { staticMetaPropsArray } from './config';
import { choiceOfSeo } from '../../../../app/helpers/choice_of_seo_helper';

export const NEWS = 'news/ACTION';
export const NEWS_REQUEST = 'news/ACTION_REQUEST';
export const NEWS_SUCCESS = 'news/ACTION_SUCCESS';
export const NEWS_FAILURE = 'news/ACTION_FAILURE';
export const SET_CATEGORY = 'news/SET_CATEGORY';

export const initialState: IPosts = {
  items: [],
  pages_count: 0,
  count: 0,
};

const defaultAction: IPostsAction = {
  type: '',
  payload: {
    data: [],
    meta: {
      pagination: {
        page: 0,
        pages: 0,
        count: 0,
      },
    },
  },
};

export const newsReducer = (state = initialState, action = defaultAction) => {
  switch (action.type) {
    case NEWS_REQUEST:
      return state;

    case NEWS_SUCCESS:
      return Object.assign({}, state, {
        items: action.payload.data,
        pages_count: action.payload.meta.pagination.pages,
        count: action.payload.meta.pagination.count,
      });

    case NEWS_FAILURE:
      return Object.assign({}, state);

    case SET_CATEGORY:
      return Object.assign({}, state, { currentCategory: action.payload.category });

    default:
      return state;
  }
};

export const getNews = (
    params: {
      page: number,
      ordering: string,
      tag: string,
      category: string,
      regionID: string,
      search: string,
    }): IGetRequest => {
  return {
    type: NEWS,
    method: 'GET',
    payload: {
      pathname: '/v1/get-news-list',
      params: [{
        name: 'page',
        value: params.page,
      }, {
        name: 'ordering',
        value: params.ordering,
      }, {
        name: 'tag',
        value: encodeURIComponent(params.tag),
      }, {
        name: 'category',
        value: params.category,
      }, {
        name: 'region_id',
        value: params.regionID,
      }, {
        name: 'q',
        value: encodeURIComponent(params.search),
      }],
    },
    request: true,
    ...options,
    staticMetaProps: choiceOfSeo(staticMetaPropsArray, params.category),
  };
};

export const setCategory = (category: string) => {
  return {
    type: SET_CATEGORY,
    payload: { category },
  };
};
